import React from "react";
import "./auth.css";
import axiosMain from "../http/axiosMain";
import { useNavigate } from "react-router-dom";
import loginimg from "../Assets/Img/loginsideimg.png";
import mobile from "../Assets/Img/mail-signup.png";
import googlesignup from "../Assets/Img/google-signup.png";
import mail from "../Assets/Img/mobile-signup.png";
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId =
  "316679652217-44dun9ch1kjuhpmqpdda6ha5t1s3shsn.apps.googleusercontent.com";

function SignUpWith() {
  const navigate = useNavigate();

  const handleGoogleSuccess = async () => {
    try {
      // const token = credentialResponse.credential; // Get Google JWT token

      const response = await axiosMain.get("api/auth/google", {
        params: {
          redirect: window.origin,
          role: "brand",
        },
      });

      if (response.data.status) {
        console.log("Authentication Successful:", response.data);
        localStorage.setItem("authToken", true);

        // Store user data
        localStorage.setItem("user", JSON.stringify(response.data.user));
        console.log("google login", response.data);
        window.location.href = response.data.data;

        // Redirect to Brand Home Page
        // navigate("/brand-home");
      } else {
        console.error("Authentication Failed:", response.data.message);
      }
    } catch (error) {
      console.error(
        "Google Login Error:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="container-signup-with-links p-0 mt-5 mb-5">
        <div className="card">
          <div className="row no-gutters">
            <div className="col-12 col-md-6 col-sm-12 left">
              <img src={loginimg} alt="login-side-img" className="img" />
            </div>
            <div className="col-12 col-md-6 col-sm-12 right">
              <div className="heading">
                <div className="title">Welcome to InSocial Orbit</div>
              </div>
              <div className="buttons">
                <button
                  type="button"
                  className="btn btn-lg mb-2 d-flex align-items-center btn-social"
                  onClick={handleGoogleSuccess}
                >
                  <img
                    src={googlesignup}
                    alt="Phone Icon"
                    className="icon mr-2"
                    style={{
                      width: "17px",
                      height: "25px",
                      marginRight: "16px",
                    }}
                  />
                  Continue with Google
                </button>
                <button
                  type="button"
                  className="btn btn-lg mb-2 d-flex align-items-center btn-social"
                  onClick={() => navigate("/signup-with-phone")}
                >
                  <img
                    src={mail}
                    alt="Phone Icon"
                    className="icon mr-2"
                    style={{
                      width: "17px",
                      height: "25px",
                      marginRight: "16px",
                    }}
                  />
                  Continue with Phone Number
                </button>
                <button
                  type="button"
                  className="btn btn-lg d-flex align-items-center btn-social"
                  onClick={() => navigate("/signup-with-email")}
                >
                  <img
                    src={mobile}
                    alt="Email Icon"
                    className="icon mr-2"
                    style={{
                      width: "25px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  Continue with Email
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}

export default SignUpWith;
